import React, { Component } from 'react'
import Icon from '../util/Icon'

export default class Headway extends Component {

  componentDidMount() {
    window.Headway.init({
      selector: ".headway",
      account: "JlmVGy"
    })
  }

  render() {
    return (
      <span className="headway">
        <Icon icon="bell" />
      </span>
    )
  }
}


// WEBPACK FOOTER //
// client/components/navigation/Headway.js